import { state as AppSate, getNet, restoreScroll } from './api.js'

const Posts = {}

let CacheStore = {}

Posts.state = {
  pageAt: 0,
  perPage: 200,
  CacheStore,
  loading: {
    feed: false,
    detail: false
  }
}

Posts.providePostByPostID = async ({ userID, postID }) => {
  CacheStore[userID] = CacheStore[userID] || []

  let item = CacheStore[userID].find(e => e._id === postID)
  if (item) {
    Posts.loadOnePost({ token: AppSate.me.jwt, postID })
      .then((post) => {
        let idx = CacheStore[userID].findIndex(e => e._id === postID)
        CacheStore[userID][idx] = post
      })
    return item
  } else {
    let post = await Posts.loadOnePost({ token: AppSate.me.jwt, postID })
    CacheStore[userID].push(post)
    return post
  }
}

Posts.getCahceOf = ({ userID }) => {
  if (CacheStore[userID]) {
    return CacheStore[userID]
  } else {
    CacheStore[userID] = CacheStore[userID] || []
    return CacheStore[userID]
  }
}

Posts.initFeed = async ({ userID }) => {
  Posts.state.pageAt = 0
  Posts.state.loading.feed = true
  await Posts.loadFeed({ userID })
  Posts.state.pageAt++
  Posts.state.loading.feed = false
  restoreScroll()
}

Posts.loadMore = async ({ userID }) => {
  Posts.state.pageAt++
  Posts.state.loading.feed = true
  await Posts.loadFeed({ userID })
  Posts.state.loading.feed = false
  restoreScroll()
}

Posts.loadFeed = async ({ userID }) => {
  let posts = await Posts.pageLatestUserPosts({ token: AppSate.me.jwt, userID: AppSate.me.user._id, skip: Posts.state.pageAt * Posts.state.perPage, limit: Posts.state.perPage })
  // console.log(posts)

  let cacheArray = Posts.getCahceOf({ userID })

  posts.forEach(e => {
    if (!cacheArray.find(a => a._id === e._id)) {
      cacheArray.push(e)
    } else {
      let idx = cacheArray.findIndex(a => a._id === e._id)
      cacheArray[idx] = e
    }
  })

  cacheArray.sort((a, b) => {
    let x = new Date(a.date).getTime()
    let y = new Date(b.date).getTime()
    if (x > y) {
      return -1
    } else if (x < y) {
      return 1
    } else {
      return 0
    }
  })
}

Posts.createPost = ({ token, title, content, date }) => {
  return getNet().post('/posts/create-post', {
    token,
    data: {
      title,
      content,
      date
    }
  }).then(r => r.data)
}

Posts.loadOnePost = ({ token, postID }) => {
  Posts.state.loading.detail = true
  return getNet().post('/posts/load-one-post', {
    token,
    data: {
      postID
    }
  }).then(r => {
    Posts.state.loading.detail = false
    return r.data.data.item
  })
}

Posts.pageLatestUserPosts = ({ token, userID, skip, limit }) => {
  return getNet().post('/posts/page-latest-user-post', {
    token,
    data: {
      userID,
      skip,
      limit
    }
  })
    .then(r => r.data)
    .then(d => d.data.items)
}

export default Posts
